<div class="stats">
  <div class="item">
    <div class="value">76,484</div>
    <div class="label">PEOPLE WORKING IN BANKING IN PA</div>
  </div>
  <div class="item it">
    <div class="value">$119,550</div>
    <div class="label">AVERAGE COMPENSATION</div>
  </div>
  <div class="item">
    <div class="value">114</div>
    <div class="label">BANKS HEADQUARTERED IN PA</div>
  </div>
</div>

<div class="illustration">
  <img src="assets/images/homepage-footer.png" alt="" routerLink="/job-match" />
  <div class="notice" routerLink="/job-match">You are just who we were looking for!</div>
</div>
